import React, { useState } from 'react';
import { TextField, Typography, Alert, CircularProgress } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import logoImg from '../../shared/svg/AppLogo/management.png';
import { authService } from '../../services/authService';
import {
    ForgotPasswordContainer,
    ForgotPasswordWrapper,
    LogoContainer,
    FormTitle,
    FormDescription,
    ButtonsContainer,
    BackButton,
    SubmitButton
} from './Styled';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            await authService.forgotPassword({ email });
            setSuccess(true);
        } catch (err: any) {
            if (err.response?.data?.email) {
                setError(err.response.data.email);
            } else if (err.response?.data?.error) {
                setError(err.response.data.error);
            } else {
                setError('Đã xảy ra lỗi. Vui lòng thử lại sau.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleBackToLogin = () => {
        navigate('/login');
    };

    return (
        <ForgotPasswordContainer maxWidth={false}>
            <ForgotPasswordWrapper elevation={3}>
                <LogoContainer>
                    <img src={logoImg} alt="Logo" />
                    <Typography variant="h5" ml={1} fontWeight="700" fontSize="32px">PMS</Typography>
                </LogoContainer>

                {success ? (
                    <>
                        <FormTitle variant="h6">
                            Đã gửi email
                        </FormTitle>
                        
                        <Alert severity="success" sx={{ mb: 3, borderRadius: '8px' }}>
                            Email đặt lại mật khẩu đã được gửi. Vui lòng kiểm tra hộp thư của bạn.
                        </Alert>
                        <FormDescription variant="body2">
                            Vui lòng kiểm tra hộp thư đến của bạn và làm theo hướng dẫn trong email để đặt lại mật khẩu.
                        </FormDescription>
                        <ButtonsContainer>
                            <BackButton
                                variant="contained"
                                onClick={handleBackToLogin}
                            >
                                Quay lại đăng nhập
                            </BackButton>
                        </ButtonsContainer>
                    </>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <FormTitle variant="h6">
                            Quên mật khẩu
                        </FormTitle>
                        
                        {error && (
                            <Alert severity="error" sx={{ mb: 3, borderRadius: '8px' }}>
                                {error}
                            </Alert>
                        )}

                        <FormDescription variant="body2">
                            Nhập địa chỉ email của tài khoản để nhận hướng dẫn đặt lại mật khẩu.
                        </FormDescription>

                        <TextField
                            fullWidth
                            label="Email"
                            name="email"
                            variant="outlined"
                            value={email}
                            onChange={handleInputChange}
                            required
                            disabled={isLoading}
                            sx={{ 
                                mb: 3,
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px'
                                },
                                '& .MuiFormLabel-asterisk': {
                                    color: '#d32f2f',
                                }
                            }}
                            type="email"
                        />

                        <ButtonsContainer>
                            <BackButton
                                variant="contained"
                                onClick={handleBackToLogin}
                                disabled={isLoading}
                            >
                                Trở lại
                            </BackButton>
                            <SubmitButton
                                type="submit"
                                variant="contained"
                                disabled={isLoading}
                            >
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Gửi yêu cầu'}
                            </SubmitButton>
                        </ButtonsContainer>
                    </form>
                )}
            </ForgotPasswordWrapper>
        </ForgotPasswordContainer>
    );
};

export default ForgotPassword; 